import { FC, SVGAttributes } from "react";

const VisaIconBackground: FC<SVGAttributes<SVGSVGElement>> = ({
  width = 32,
  height = 24,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 34 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Visa</title>
    <path
      d="M4.7461 1.08655H29.2539C31.3175 1.08655 33 2.7976 33 4.92019V21.2529C33 23.3755 31.3175 25.0865 29.2539 25.0865H4.7461C2.68244 25.0865 1 23.3755 1 21.2529V4.92019C1 2.7976 2.68244 1.08655 4.7461 1.08655Z"
      fill="white"
      stroke="#EEEEEE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.3092 11.9182C17.2989 12.754 18.0307 13.2204 18.5821 13.4977C19.1485 13.7822 19.3388 13.9647 19.3366 14.2191C19.3323 14.6085 18.8848 14.7804 18.4659 14.7871C17.7548 14.7985 17.3334 14.5949 17 14.4338L16.9724 14.4205L16.7092 15.692C17.0481 15.8533 17.6756 15.9939 18.3264 16C19.8539 16 20.8533 15.2217 20.8587 14.0149C20.8622 13.0987 20.127 12.7002 19.5387 12.3814C19.1436 12.1672 18.8148 11.989 18.8204 11.714C18.8253 11.5064 19.0172 11.2849 19.4377 11.2286C19.6458 11.2001 20.2203 11.1783 20.8717 11.488L21.1273 10.2578C20.7771 10.1261 20.3268 10 19.7663 10C18.3286 10 17.3173 10.7889 17.3092 11.9182ZM23.5839 10.106C23.305 10.106 23.0699 10.2739 22.965 10.5317L20.783 15.9096H22.3094L22.6132 15.0431H24.4785L24.6547 15.9096H26L24.826 10.106H23.5839ZM24.2379 13.8531L23.7974 11.6738L23.0315 13.8531H24.2379ZM15.4585 10.106L14.2553 15.9096L15.7098 15.9096L16.9124 10.106H15.4585ZM11.7927 14.0562L13.3067 10.106H14.8342L12.4776 15.9096H10.9404L9.78043 11.2782C9.71017 10.9931 9.64909 10.8882 9.43505 10.7683C9.08534 10.5719 8.50808 10.3883 8 10.2745L8.03459 10.106H10.5096C10.8247 10.106 11.1085 10.3225 11.1804 10.6974L11.7927 14.0562Z"
      fill="#27337A"
    />
  </svg>
);

export default VisaIconBackground;
